import { MfeLoad } from '@carvana/microfrontend';
import { useEffect, useRef } from 'react';
import { MfeReactComponent } from '@carvana/microfrontend-react';

import MicroFallback from '../components/_shared/MicroFallback';
import useMfeInterface from '../context/useMfeInterface';
import { startSpan } from '../utilities/dataDog';
import type { MfeChildProps } from '../mfeTypes';

const AppraisalModule = () => {
  const mfeInterface = useMfeInterface();
  const mfeLoadSpan = useRef(startSpan('MFE:Appraisal', 'Load'));
  const loaded = useRef(false);

  useEffect(() => {
    MfeLoad({
      files: [
        [
          'AppraisalModule',
          [
            {
              component: 'default',
              browser: true,
              local: {
                file: 'index.js',
                manifest: `http://localhost:5005/assets-manifest.json?v=${Date.now()}`
              },
              default: {
                file: 'index.js',
                manifest: `${
                  process.env.CARVANA_APP_STATIC_PUBLIC_URL
                }/stc-appraisal-ui/modules/assets-manifest.json?v=${Date.now()}`
              }
            }
          ]
        ]
      ]
    });

    const slowTimer = setTimeout(() => {
      if (!loaded.current) mfeLoadSpan.current.addEvent('SlowLoad');
    }, 8000);
    const reallySlowTimer = setTimeout(() => {
      if (!loaded.current) mfeLoadSpan.current.addEvent('ReallySlowLoad');
    }, 15000);

    return () => {
      clearTimeout(slowTimer);
      clearTimeout(reallySlowTimer);
    };
  }, []);

  return (
    <MfeReactComponent
      component="default"
      module="AppraisalModule"
      loading={<MicroFallback span={mfeLoadSpan.current} />}
      fallback={{
        Component: <MicroFallback errorReportTimeout={1} span={mfeLoadSpan.current} />,
        timeout: 30000
      }}
    >
      {({ Component }: MfeChildProps) => {
        loaded.current = true;
        mfeLoadSpan.current.addEvent('Success');
        mfeLoadSpan.current.end();
        return <Component mfeInterface={mfeInterface} />;
      }}
    </MfeReactComponent>
  );
};

export default AppraisalModule;
